<!--
 * @Author: ningbo.kang
 * @Date: 2020-06-02 17:43:31
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-07-27 13:20:47
 * @Description: 描述
 -->

<template>
  <a-form-item
    v-if="!options.hidden"
    :label="label"
    :class="[{ 'ant-form-item-disabled': disabled }]"
    :required="!disabled && required"
  >
    <widgetItem
      :fieldName="widget.model"
      :widget="widget" :disabled="disabled"
      :isNested="isNested"
      :showLabel="showLabel"
      :rowIndex="rowIndex"
      :parentName="parentName"
      :parentModel="parentModel"
      v-decorator="decorator"
      @noticeParent="handleNoticeParent"
      @change="handleChange"
    >
    </widgetItem>
  </a-form-item>
</template>
<script>
import props from '../../lib/props';
import widgetItem from './processSelect.vue';

export default {
  name: 'wgProcessSelect',
  mixins: [props],
  components: {
    widgetItem,
  },
};
</script>
